import { createFileRoute } from '@tanstack/react-router'
import { IncidentCreate } from '@/features/incidents/create'

export const Route = createFileRoute('/_authenticated/_organization/incidents/new')({
  component: IncidentCreate,
})

